import { SegmentedControl, useMantineTheme } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { CardTableView } from '@dealstack/frontend/shared/components/CardTableViewSelector/CardTableViewSelector.types.ts';

interface Props {
	value: CardTableView;
	onViewChange: (view: CardTableView) => void;
	controlSize?: number;
}

export const CardTableViewSelector = ({ value, onViewChange, controlSize = 32 }: Props) => {
	const theme = useMantineTheme();

	return (
		<SegmentedControl
			size="sm"
			value={value}
			onChange={(next) => onViewChange(next as CardTableView)}
			transitionDuration={200}
			transitionTimingFunction="ease"
			styles={{
				root: {
					borderRadius: '0.375rem',
					border: `1px solid ${theme.colors.gray[4]}`,
					padding: '2px',
				},
				label: {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					minWidth: `${controlSize}px`,
					minHeight: `${controlSize}px`,
					padding: 0,
				},
				indicator: {
					margin: '0',
					backgroundColor: theme.colors.blue[0],
					border: `1px solid ${theme.colors.blue[6]}`,
					borderRadius: '0.25rem',
					boxShadow: 'none',
				},
			}}
			data={[
				{
					label: <Icon variant="grid-2" size="lg" />,
					value: 'cards',
				},
				{
					label: <Icon variant="table-v3" size="lg" />,
					value: 'table',
				},
			]}
		/>
	);
};
